<template>
  <div>
    <div v-if="$route.name != 'PanelDetails' && isLaptop"><SideBar /></div>
    <div>
      <transition name="fade-transform" mode="out-in">
        <router-view :class="menuStatus ? 'extra-width' : ''" />
      </transition>
    </div>
  </div>
</template>

<script>
import SideBar from "../fixedcomponents/sideBar.vue";
import { mapGetters } from "vuex";

export default {
  name: "AppMain",
  data() {
    return {
      isLaptop: true,
    };
  },
  components: {
    SideBar,
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      menuStatus: "getMenuStatus",
    }),
  },
};
</script>

<style>
.extra-width {
  margin-left: 170px;
}
</style>
